{
  "howitworks": "Cómo funciona",
  "howitworksPhrase1Part1": "Es hora de hacer un mundo ",
  "howitworksPhrase1Part2": "un poco ",
  "howitworksPhrase1Part3": "mucho mejor.",
  "or": "o",

  "howitworksPhrase2Part1": "Si tienes un proyecto que ya está en marcha ",
  "howitworksPhrase2Part2": " una visión que todavía es solo un destello de una idea,",
  "howitworksPhrase2Part3": " RebelBase te brinda los medios para lanzar tus proyectos y crear un mundo diferente.",

  "BuildTitle": "El mundo real se encuentra con el aula y las chispas vuelan.",
  "BuildPhase1": "Hacer workshops ",
  "BuildPhase1TextPart1": "- triviales,",
  "BuildPhase1TextPart2": "intuitivos, son todo lo que necesitas para desarrollar tu idea. ",
  "BuildPhase1TextPart3": "Sumérgete de inmediato, no es necesario un MBA. ",

  "BuildPhase2": "Builders completos",
  "BuildPhase2TextPart1": " — presenta los builders directamente sobre el problema que estás empeñado en abordar.",
  "BuildPhase2TextPart2": "Descubre tu solución, demuestra tu potencial,",
  "BuildPhase2TextPart3": " comunica tu valor y traza un camino para que crezca.",

  "BuildPhase3": "Comete errores",
  "BuildPhase3TextPart1": " — RebelBase es un lugar seguro para tropezar.",
  "BuildPhase3TextPart2": " Los expertos y los miembros de la comunidad te ayudarán a saber qué funciona y qué deberia funcionar. ",
  "signUptoBuildLink": "Regístrate gratis para acceder a los builders",

  "ShowcaseTitle": "Atrapa a las personas que más necesitas.",
  "ShowcasePhase1": "Crea una página de proyecto",
  "ShowcasePhase1TextPart1": " — es tu empresa de un vistazo. ",
  "ShowcasePhase1TextPart2": "Tu perfil se actualiza automáticamente a medida que ganas premios, ",
  "ShowcasePhase1TextPart3": " recibes felicitaciones en forma de kudos y builders que completas. ",

  "ShowcasePhase2": "Da una brillante primera impresión",
  "ShowcasePhase2TextPart1": " — fijando tus logros y experiencias en la página de tu proyecto. ",
  "ShowcasePhase2TextPart2": "Es lo que la gente verá primero. Distínguete, gana recursos, ",
  "ShowcasePhase2TextPart3": "atrae talento crítico, recauda capital o consigue un trabajo.",

  "ShowcasePhase3": "Personaliza tu configuración de privacidad",
  "ShowcasePhase3TextPart1": "— elige quién puede ver qué. ",
  "ShowcasePhase3TextPart2": "Manten los detalles del proyecto en secreto, compártelos con aquellos que elijas o publícalos para que todo el mundo los vea.",
  "ProjectPagesLink": "Examina las páginas del proyecto",

  "ConnectTitle": "Se necesita una comunidad, comienza con una virtual.",
  "ConnectPhase1": "Construye un equipo de ensueño",
  "ConnectPhase1TextPart1": "— Están aquí en la amplia red de networking y comunidades de RebelBase. ",
  "ConnectPhase1TextPart2": "Busca talentos, mentores, socios e inversores en tu comunidad y fuera de ella. ",

  "ConnectPhase2": "Colabora con facilidad",
  "ConnectPhase2TextPart1": "— utilizando un espacio de trabajo compartido online. ",
  "ConnectPhase2TextPart2": "Aborda problemas, carga archivos y compara opiniones sin los congestionados confines de la geografía.",

  "ConnectPhase3": "Refina y avanza",
  "ConnectPhase3TextPart1": "— basado en aportes de compañeros, usuarios potenciales y expertos de la industria. ",
  "ConnectPhase3TextPart2": "Encuentra talento, recursos y conocimientos en días de presentaciones, hackatones, concursos y foros. "
}
